export default __webpack_public_path__ + "static/media/50X.f712acac.svg";